import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * ユーザープロフィールの完了状態を取得するカスタムフック
 */
export const useUserProfile = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['userProfile', 'check'],
    queryFn: async () => {
      try {
        const data = await apiClient.checkUserProfile();
        return data;
      } catch (error) {
        // エラーが発生した場合、プロフィール未完了として扱う
        console.error('Failed to check user profile:', error);
        return { completed: false };
      }
    },
    enabled: enabled && !!apiClient.getIdToken(),
    staleTime: 60 * 1000, // 1分間キャッシュ
    retry: 1, // エラー時に1回のみリトライ
  });
};

export default useUserProfile;
